<template>
  <div style="padding: 20px;background-color: #ffffff;">
    <div class="">
      <div @keyup.enter.stop="getPage({pageNum: 1})">
        <el-select v-model="queryParam.batchId" @change="getSpecialtyList" placeholder="选择考试" filterable style="width:200px;margin-right:10px;">
          <el-option v-for="(item,index) in batchList" :key="index" :label="item.batchName" :value="item.batchId" :class="item.disabled?'none':''"></el-option>
        </el-select>
        <el-select v-model="queryParam.agentId" placeholder="承办单位" @change="getPage({pageNum: 1})" filterable style="width:200px;margin-right:10px;margin-bottom: 10px;">
          <el-option v-for="(item,index) in agentList" :key="index" :label="item.agentName" :value="item.agentId" :class="item.disabled?'none':''"></el-option>
        </el-select>
        <el-date-picker v-model="publishTime" type="daterange" range-separator="至" start-placeholder="创建开始日期" end-placeholder="创建结束日期"
                        value-format="yyyy-MM-ddTHH:mm:ss" :default-time="['00:00:00','23:59:59']" style="width:410px;margin-right:10px;margin-bottom: 10px;"></el-date-picker>
        <el-button @click="getPage({pageNum: 1})" type="primary">搜索</el-button>
        <el-button @click="queryParam=JSON.parse(JSON.stringify(oldQueryParam)),getPage({pageNum: 1}),getSpecialtyList()" type="default">重置</el-button>
<!--        <el-button @click="exportExcel()" type="primary" style="margin-left: 10px;">导出考前备案表</el-button>-->
      </div>
    </div>
    <div ref="page" style="margin-top: 12px;">
      <el-table :data="page.list" stripe :height="tableHeight" size="medium" @selection-change="multipleSelection=$event">
        <el-table-column type="selection" width="55" :selectable="row=>row.auditStatus==2"></el-table-column>
        <el-table-column prop="agentName" label="承办单位"></el-table-column>
        <el-table-column prop="specialtyName" label="报考专业"></el-table-column>
        <el-table-column prop="enrollCount" label="报名人数"></el-table-column>
        <el-table-column prop="mainUserName" label="考级点负责人"></el-table-column>
        <el-table-column prop="phone" label="考点负责人电话"></el-table-column>
        <el-table-column prop="addTime" label="创建时间"></el-table-column>
        <el-table-column prop="auditStatus" label="审核状态">
          <template slot-scope="scope">
            {{$enums.auditStatus[scope.row.auditStatus]}}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="220">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="edit(scope.row)">
              查看详情
            </el-button>
            <el-button v-if="scope.row.auditStatus != 2" size="mini" type="text" @click="pass(scope.row)">审核通过</el-button>
            <el-button v-if="scope.row.auditStatus != 3" size="mini" type="text" @click="unPass(scope.row)" style="color: #E91212;"> 审核不通过</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 20px;">
        <el-pagination class="text-center" background
                       :page-sizes="[20, 50, 100, 200]" layout="total, sizes, prev, pager, next, jumper"
                       :total="page.total" :page-size="page.pageSize" :current-page="page.pageNum"
                       @current-change="getPage({pageNum:$event})" @size-change="getPage({pageNum:1,pageSize:$event})"></el-pagination>
      </div>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%">
      <p>当前进度</p>
      <div style="text-align: center">
        <el-progress type="circle" :percentage="percent"></el-progress>
      </div>
    </el-dialog>
  </div>
</template>
<script>

export default {
  name: 'beforeEdit',
  components: { },
  props: [],
  data () {
    return {
      tableHeight: 200,
      queryParam: { batchId: this.$route.query.batchId },
      oldQueryParam: {},
      page: { pageSize: 20, pageNum: 1 },
      multipleSelection: [],
      editForm: { show: false, row: null, title: '详情' },
      batchList: [],
      specialtyList: [],
      agentList: [],
      publishTime: [],
      percent: null,
      dialogVisible: false
    }
  },
  async created () {
    this.batchList = await this.$HTTP.ApiBatch.getList({ batchStatus: [2, 3] })
    if (this.Tool.isNull(this.batchList)) {
      throw new Error('没有考试数据')
    }
    if (!this.queryParam.batchId) {
      this.queryParam.batchId = this.batchList[0].batchId
    }
    await this.getSpecialtyList()
    await this.getPage()
    this.oldQueryParam = JSON.parse(JSON.stringify(this.queryParam))
  },
  async mounted () {
    this.Tool.windowResizeEvent(() => {
      this.tableHeight = this.Tool.calcTableHeight(this.$refs['page'])
    })
  },
  async beforeDestroy () {
  },
  computed: {},
  watch: {},
  methods: {
    async getSpecialtyList (event) {
      this.agentList = await this.$HTTP.ApiBatch.getAgentList(this.queryParam.batchId)
      if (event) {
        this.queryParam.agentId = ''
      }
      await this.getPage()
    },
    async getPage (queryParam) {
      try {
        this.dialogVisible = false
        if (this.publishTime) {
          this.$set(this.queryParam, 'startTime', this.publishTime[0])
          this.$set(this.queryParam, 'endTime', this.publishTime[1])
        } else {
          this.queryParam.starTime = ''
          this.queryParam.endTime = ''
        }
        this.queryParam = Object.assign({recordsType: 0}, this.queryParam, queryParam)
        let page = await this.$HTTP.ApiCommon.getRecordPage(this.queryParam)
        if (page.list) {
          page.list.map(el => {
            this.$set(el, 'examineeIdNo2', el.examineeIdNo)
            this.$set(el, 'examineeName2', el.examineeName)
            this.$set(el, 'trueEye2', true)
            this.$set(el, 'trueEye', true)
            // el.examineeIdNo2 = el.examineeIdNo.replace(/^(.{6})(?:\w+)/, "\$1********")
            // el.examineeName2 = el.examineeName.replace(/(?<=.)./g, '*')
            if (el.examineeIdNo) {
              el.examineeIdNo2 = el.examineeIdNo.replace(/^(.{6})(?:\w+)/, "\$1********")
            }
            if (el.examineeName) {
              el.examineeName2 = el.examineeName.replace(/(?<=.)./g, '*')
            }
          })
        }
        this.page = page
        this.$nextTick(() => {
          let wrapper = window.document.getElementsByClassName('el-table__body-wrapper')
          if (wrapper) {
            wrapper[0].scrollTop = 0
          }
        })
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    edit (row) {
      this.$router.push(`/workflow/examination-record-detail?auditlogId=${row.auditlogId}&name=bfEdit`)
    },
    async pass (row) {
      let confirm = await this.$confirm('确定通过该记录吗？', '提示', { type: 'warning' })
      if (confirm === 'confirm') {
        const param = {
          auditIds: [row.auditlogId],
          isPass: 1
        }
        await this.$HTTP.ApiCommon.changeAudit(param)
        this.$message({ type: 'success', message: '操作成功' })
        await this.getPage()
      }
    },
    async unPass (row) {
      let confirm = await this.$confirm('确定不通过该记录吗？', '提示', { type: 'warning' })
      if (confirm === 'confirm') {
        const param = {
          auditIds: [row.auditlogId],
          isPass: 0
        }
        await this.$HTTP.ApiCommon.changeAudit(param)
        this.$message({ type: 'success', message: '操作成功' })
        await this.getPage()
      }
    },
    async exportExcel (row) {
      try {
        let auditlogIds = this.Tool.joinList(this.multipleSelection, 'auditlogId')
        this.queryParam.auditlogIds = auditlogIds.join(',')
        await this.$HTTP.ApiCommon.exportExcelBf(this.queryParam)
        this.getTaskInfo('export_records_audit')
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    getTaskInfo (taskName) {
      this.taskInterval = setInterval(async () => {
        try {
          let taskInfo = await this.$HTTP.ApiExamResult.getTaskInfo(taskName)
          this.percent = taskInfo.percent
          if (taskInfo) {
            this.dialogVisible = true
            if (taskInfo.errorExcelUrl) {
              clearInterval(this.taskInterval)
              if (taskInfo.errMsg) {
                this.$message({ type: 'error', message: taskInfo.errMsg })
              }
              let fileUrl = await this.$HTTP.ApiOss.signatureUrl(taskInfo.errorExcelUrl, 'temp')
              this.Tool.downloadFile(fileUrl)
              await this.getPage()
            } else if (taskInfo.successExcelUrl) {
              clearInterval(this.taskInterval)
              let fileUrl = await this.$HTTP.ApiOss.signatureUrl(taskInfo.successExcelUrl, 'temp')
              this.Tool.downloadFile(fileUrl)
              await this.getPage()
            } else if (taskInfo.percent >= 100) {
              clearInterval(this.taskInterval)
              this.$message({ type: 'success', message: '操作成功' })
              await this.getPage()
            } else if (taskInfo.status >= 2) {
              clearInterval(this.taskInterval)
              if (taskInfo.errMsg) {
                this.$message({ type: 'error', message: taskInfo.errMsg })
              }
              await this.getPage()
            }
          } else {
            clearInterval(this.taskInterval)
          }
          if (taskInfo.percent >= 100) {
            this.dialogVisible = false
          }
        } catch (e) {
          clearInterval(this.taskInterval)
          this.Tool.doError(e)
        }
      }, 2000)
    }
  }
}
</script>
